import React, { useEffect, useState } from 'react'
import { LocalizationContext, LocalizationMap, SpecialZoomLevel, Viewer } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { getFilePlugin } from '@react-pdf-viewer/get-file';

import es_ES from '@react-pdf-viewer/locales/lib/es_ES.json';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';


export type PropsPDFViewer = {
    url: string,
    heightValue: string,
    zoomDefaultValue?: number,
    downloadFileName?: string
}

const PDFViewer = (props: PropsPDFViewer) => {
    const [l10n, setL10n] = useState(es_ES as any as LocalizationMap);
    const localizationContext = { l10n, setL10n };


    const zoomPluginInstance = zoomPlugin({enableShortcuts:true});
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

    const getFilePluginInstance = getFilePlugin({
        fileNameGenerator: props.downloadFileName
            ? () => props.downloadFileName!
            : undefined,
    });
    const { DownloadButton } = getFilePluginInstance;

    useEffect(() => {
      if(zoomPluginInstance && props.zoomDefaultValue){
        zoomPluginInstance.zoomTo(props.zoomDefaultValue);
      }

    }, [zoomPluginInstance])
    

    return (
        <LocalizationContext.Provider value={localizationContext}>
            <div
                style={{
                    alignItems: 'center',
                    backgroundColor: '#eeeeee',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '4px',
                }}
            >
                <ZoomOutButton />
                <ZoomPopover />
                <ZoomInButton />
                <DownloadButton />
            </div>
            <div
                style={{
                    flex: 1,
                    overflow: 'hidden',
                    height: props.heightValue
                }}
            >
                <Viewer
                    fileUrl={encodeURI(props.url)}
                    localization={es_ES as unknown as LocalizationMap}

                    plugins={[
                        zoomPluginInstance,
                        getFilePluginInstance,
                    ]}
                    defaultScale={SpecialZoomLevel.ActualSize}
                />
            </div>

        </LocalizationContext.Provider>

    )
}


export default PDFViewer
